import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Click Outside Directive
 *
 * Emits an event when user clicks outside the host element.
 * Useful for closing dropdowns, modals, etc.
 *
 * Usage:
 * ```html
 * <div (hcClickOutside)="closeDropdown()">
 *   Dropdown content
 * </div>
 * ```
 */
@Directive({
    selector: '[hcClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  @Output() hcClickOutside = new EventEmitter<MouseEvent>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    // Check if click is outside the element
    if (!this.elementRef.nativeElement.contains(target)) {
      this.hcClickOutside.emit(event);
    }
  }
}
